module.exports = __webpack_public_path__ + "static/media/ic_close.44b43169.svg";